export default __webpack_public_path__ + "static/media/bg-pattern-header.f3307602.svg";